
export class CompanyPolicyModel{
    id: number;
    name: string;
    description: string;
}
